import { t } from '@lingui/macro';

/**
 * A Sentinel team created without any platform account cannot be opened, so
 * the team name is rendered disabled. Both the Fleet Admin teams list and the
 * super-admin teams list gray out rows for the same reason, and both surface
 * the same explanation as a tooltip on the disabled name.
 */
export const hasNoPlatformAccounts = (
  platformAccounts?: unknown[] | null,
): boolean => !platformAccounts || platformAccounts.length === 0;

export const noPlatformAccountsReason = () =>
  t`This team has no accounts associated with it, please add an account to enable this team.`;
